import React from 'react';
import gql from 'graphql-tag';
import {FormattedMessage} from 'react-intl';
import Experiment from '@homeaway/react-experiment';
import {HA_SERP_DESTINATION_URGENCY_MSG} from '../../abacus/experiments';

export const fragments = {
    searchBanner: gql`
        fragment UrgentMessageSearchBanner on SearchBanner {
            countOfVisitors
            location
        }
    `
};

export function Content({countOfVisitors, location}) {
    return (
        <Experiment name={HA_SERP_DESTINATION_URGENCY_MSG} variant={0}>
            <div className="UrgentMessageSearchBannerContent">
                <span className="SearchBanner__callToAction">
                    <FormattedMessage
                        id="percentBookedPopularTitle"
                        defaultMessage="Book soon!"
                    />
                </span>
                <span className="SearchBanner__explanation">
                    <FormattedMessage
                        id="countOfVisitorsLookingAtLocation"
                        description=""
                        values={{
                            countOfVisitors,
                            location
                        }}
                    />
                </span>
            </div>
        </Experiment>
    );
}

export default {
    fragments,
    Content
};
